window.AlertUi = class
{
	static modal = async function (data, options = {}) {

		var dfd = $.Deferred();
		options = $.extend({}, {
			stack: true,
			mode: '',
			backdrop: 'static',
			autoclose: 0,
		}, options);

		const modal = new ModalUi(options);

		// Genera el template y lo visualiza.
		let $modal = await modal.loadFromTemplate("modal-confirm", data);
		modal.render();

		// Genera un Bind al evento de cierre del modal. De suceder hace un reject a la promise.
		$modal
			.on('hidden.bs.modal', function (e) {
				$(this).off('hidden.bs.modal');
				dfd.reject({ isError : false });
			});
		// Bind al click en el boton principal. De suceder la promise se resuelve.
		$modal
			.find("#modal-confirm-btn, [data-resolve='modal']")
			.on("click", function (e) {
				dfd.resolve( $(this).attr('data-value') ); // resolver primero success
				modal.hide(); // luego cerrar modal - ya que va a querer llamar el bind de hidden y ahi se rejecta la promise
			});


		if (options.autoclose > 0) {
			let $progress = $modal.find('span.modal-close.animated-progress');
			$progress[0].animate(
				[{
					width: '0%',
				},
					{
						width: $progress.attr("data-progress") + "%",
					}],
				{
					duration: options.autoclose
				}
			);

			UtilityHelper.sleep(options.autoclose).then(function () {
				dfd.resolve();
				modal.hide();
			});
		}

		if (options.delay > 0) {
			$modal.find("#modal-confirm-btn, [data-resolve='modal']").attr('disabled', true);

			let $progress = $modal.find('span.modal-close.animated-progress');
			$progress[0].animate(
				[{
					width: '0%',
				},
					{
						width: $progress.attr("data-progress") + "%",
					}],
				{
					duration: options.delay
				}
			);

			UtilityHelper.sleep(options.delay).then(function () {
				$modal.find("#modal-confirm-btn, [data-resolve='modal']").attr('disabled', false);
			});
		}

		return dfd;
	}

	static confirm = async function (data, options) {
		return this.modal($.extend({type: 'confirm'}, data), options);
	}

	static delete = async function (data, options) {
		return this.modal($.extend({type: 'delete'}, data), options);
	}

	static success = async function (phrase, message = '', options) {
		return this.modal({
			'title': '<i class="fa fa-check-circle fa-2x"></i>',
			'msg': phrase ? PhrasesService.get(phrase) : message,
			'type': 'OK',
		}, options);
	}

	static error = async function (phrase, message = '', options) {
		if(phrase) {
			await PhrasesService.load(phrase);
		}
		return this.modal({
			'title': '<i class="fa fa-circle-exclamation fa-2x"></i>',
			'msg': phrase ? PhrasesService.get(phrase) : message,
			'type': 'OK',
		}, options);
	}

	static bug = async function (phrase, message = '', options) {
		return this.modal({
			'title': '<i class="fa fa-bug fa-2x"></i>',
			'msg': phrase ? PhrasesService.get(phrase) : message,
			'type': 'OK',
		}, options);
	}
};
